import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';

export function useOnVisible(options = {}) {
  const target = ref(null);
  const visible = ref(false);
  let observer;

  onMounted(async () => {
    await nextTick();
    if (typeof IntersectionObserver === 'undefined' || !target.value) {
      visible.value = true;
      return;
    }

    observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          visible.value = true;
          observer.disconnect();
        }
      },
      {
        root: options.root || null,
        rootMargin: options.rootMargin || '200px 0px',
        threshold: 0.01,
      }
    );
    observer.observe(target.value);
  });

  onBeforeUnmount(() => observer?.disconnect());

  return { target, visible };
}
